<template>
  <v-btn
    v-bind="{
      color: bgDark,
      height: 48,
      rounded: true,
      width: 196,
      variant: 'flat',
      ...$props,
      ...$attrs,
    }"
  >
    <slot />
  </v-btn>
</template>
<script>
import { useColors } from '@/composables/colors';

export default {
  name: 'DpplGoogleLinkedinButton',
  setup() {
    const { bgDark } = useColors();

    return { bgDark };
  },
};
</script>
